module.exports = __webpack_public_path__ + "static/media/i4c-solutions.e14c7448.svg";